module.exports = __webpack_public_path__ + "static/img/pinpai-20.eb1ea6b1.png";